import CarouselButtons from 'components/carousel2025/CarouselButtons';
import EmblaCarousel from 'components/carousel2025/EmblaCarousel';
import ImageWithFallback from 'components/ImageWithFallback';
import useEmblaCarousel from 'embla-carousel-react';
import Link from 'next/link';
import { WinnerHomepage } from 'utils/plasmicCMS';
import styles from './WinnerCarousel.module.css';

// Group winners into pages of 4 for 2x2 grid display
const chunkArray = <T,>(arr: T[], size: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

interface WinnerCarouselProps {
  winners?: WinnerHomepage[];
}

export const WinnerCarousel = ({ winners }: WinnerCarouselProps) => {
  const emblaCarouselInfo = useEmblaCarousel({
    loop: true,
    duration: 10,
    inViewThreshold: 0.1,
    align: 'start',
  });

  const winnersData = winners && winners.length > 0 ? winners : [];
  const winnerPages = chunkArray(winnersData, 2);

  return (
    <div className={styles.carouselContainer}>
      <EmblaCarousel
        className={styles.winnerCarousel}
        emblaCarouselInfo={emblaCarouselInfo}
        items={winnerPages.map((page, pageIndex) => (
          <div key={pageIndex} className={styles.carouselSlide}>
            <div className={styles.winnersGrid}>
              {page.map((winner, index) => (
                <Link
                  key={index}
                  href="/winners"
                  className={styles.carouselContent}
                >
                  <div className={styles.carouselImageWrapper}>
                    <ImageWithFallback
                      layout="fill"
                      objectFit="cover"
                      src={{
                        src: winner.image.url,
                        width: 300,
                        height: 300,
                      }}
                      className={styles.carouselImage}
                    />
                    <div className={styles.carouselOverlay} />
                    <div className={`${styles.carouselTextContent}`}>
                      <h3
                        className={
                          'aboutUsTypographyHeaderMedium textAlignLeft'
                        }
                      >
                        {winner.winnerName}
                      </h3>
                      <p className="aboutUsTypographyBodySmall noMargin singleLineEllipsis">
                        {winner.prizeName}
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        ))}
      />
      <CarouselButtons
        changeSelectedIndex={(x) =>
          x < 0
            ? emblaCarouselInfo[1]?.scrollPrev()
            : emblaCarouselInfo[1]?.scrollNext()
        }
      />
    </div>
  );
};
